/**
 * useQuerySchema
 * Fetches and caches the dynamic query schema (entities, fields, relationships).
 * The schema rarely changes, so it is cached for 10 minutes.
 */
import { useQuery } from '@tanstack/react-query';
import { queryService } from '@services';

export const useQuerySchema = (enabled = true) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['querySchema'],
    queryFn: () => queryService.getSchema(),
    staleTime: 10 * 60 * 1000,
    enabled,
  });

  return {
    schema: data,
    entities: data?.entities ?? [],
    relationships: data?.relationships ?? [],
    isLoading,
    error,
  };
};
